export default __webpack_public_path__ + "static/media/noun-tick.a76fd1f3.svg";